import axios from "axios";
import { getColabServerUrl } from "./getUrl";

export const isSessionActiveCheck = async (sessionId: string | null) => {
	return new Promise<boolean>(async (resolve, reject) => {
		try {
			if (!sessionId) {
				reject("invalidToken.loginRequired");
			}

			const colab_url = getColabServerUrl();
			const resp = await axios.get(
				`https://${colab_url}/api/v1/editor-session/`,
				{
					withCredentials: true,
				},
			);

			const activeSessions = resp.data.map((s: any) => s.id);
			if (activeSessions.includes(Number(sessionId))) {
				resolve(true);
			} else {
				resolve(false);
			}
		} catch (error) {
			reject("invalidToken.loginRequired");
		}
	});
};

